import { IUser } from '@/interfaces/entities/user';

export default function FamilyMembersSection({ user }: { user: IUser }) {
	return (
		<div className="mt-4">
			<hr className="mt-4 mb-4 border-t-2 border-gray-300" />
			<h2 className="text-2xl font-bold mb-4">Family Info</h2>
			<div className="overflow-auto w-full h-64">
				{user.family &&
					user.family.length > 0 &&
					user.family.map((child, index) => (
						<div key={`${user.id}-${index}`} className="mb-4">
							<h3 className="text-xl font-bold">Child {index + 1}:</h3>
							<div>
								<b>Name:</b> {child.firstName} {child.lastName}
							</div>
							<div>
								<b>Age:</b> {child.age}
							</div>
							<div>
								<b>Gender:</b> {child.gender}
							</div>
							<div>
								<b>Interests:</b>{' '}
								{Array.isArray(child.interests)
									? child.interests.map((interest) => interest.title).join(', ')
									: 'No interests'}
							</div>
							<div>
								<b>About:</b> {child.about}
							</div>
						</div>
					))}
			</div>
		</div>
	);
}
